<template>
  <div class="company__setting">
    <form>
      <div class="company__setting--basic">
        <span>All fields marked * are required</span>
        <div v-if="scrollToJobTitle" class="scrollButton">
          <button @click.prevent="scroll">Go to Create job title</button>
        </div>
        <p>Basic:</p>
        <div>
          <div class="company__setting--basic-text">
            Company Name
            <span>*</span>
          </div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="legalName" disabled="disable" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Tax ID Number
            <span>*</span>
          </div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="tax" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Registration Number
            <span>*</span>
          </div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="registration" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text bvn-input">
            BVN
            <span>*</span>
          </div>
          <div>
            <div class="company__setting--basic-input">
              <input type="text" v-model="bvn" />
            </div>
            <span class="bvn-span"
              >We need your BVN to enable us create a virtual account for
              you</span
            >
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Country
            <span>*</span>
          </div>
          <div class="company__setting--basic-input" v-show="country">
            <select v-model="selectedCountry" @change="getState($event)">
              <option
                v-for="countryValue in countryData"
                :value="countryValue.name"
                v-bind:key="countryValue.index"
              >
                {{ countryValue.name }}
              </option>
            </select>
            <div>
              <font-awesome-icon icon="angle-down" />
            </div>
          </div>
          <div class="company__setting--basic-input-loader" v-show="!country">
            <InputLoader />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            State
            <span>*</span>
          </div>
          <div class="company__setting--basic-input" v-show="state">
            <select v-model="selectedState">
              <option>-- select --</option>
              <option
                v-for="stateValue in stateData"
                :value="stateValue.name"
                v-bind:key="stateValue.index"
              >
                {{ stateValue.name }}
              </option>
            </select>
            <div>
              <font-awesome-icon icon="angle-down" />
            </div>
          </div>
          <div class="company__setting--basic-input-loader" v-show="!state">
            <InputLoader />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">City</div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="city" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Address
            <span>*</span>
          </div>
          <div class="company__setting--basic-textarea">
            <textarea type="text" v-model="address"></textarea>
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">Website</div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="website" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Email
            <span>*</span>
          </div>
          <div class="company__setting--basic-input">
            <input readonly type="text" v-model="email" />
          </div>
        </div>
        <div>
          <div class="company__setting--basic-text">
            Phone
            <span>*</span>
          </div>
          <div class="company__setting--basic-input">
            <input type="text" v-model="phone" />
          </div>
        </div>

        <div>
          <div class="company__setting--basic-text">Industry</div>
          <div class="company__setting--basic-input" v-show="industry">
            <select v-model="selectedIndustry">
              <option
                v-for="industryValue in industryData"
                :value="industryValue.name"
                v-bind:key="industryValue.index"
              >
                {{ industryValue.name }}
              </option>
            </select>
            <div>
              <font-awesome-icon icon="angle-down" />
            </div>
          </div>
          <div class="company__setting--basic-input-loader" v-show="!industry">
            <InputLoader />
          </div>
        </div>

        <div>
          <p class="company__setting--basic-error" v-show="fileError">
            File must be an image file with png/jpg extension.
          </p>
        </div>
      </div>
      <div class="company__setting--error">
        <span v-show="networkError"
          >We experienced a network error. Please try again.</span
        >
        <span v-show="successMsg">Company updated successfully.</span>
        <span v-show="formError"
          >The following fields are important, Country, State, Tax, BVN, number,
          Trading name, registration number, email, and Phone number.</span
        >
      </div>
      <div class="company__setting--save">
        <button v-show="!submitLoader" @click.prevent="submitSettingUpdate">
          Save Settings
        </button>
        <div v-show="submitLoader">
          <WhiteLoader />
        </div>
      </div>
      <div ref="targetDiv"></div>
    </form>

    <div class="company__setting--sections">
      <div class="company__setting--section company__setting--section-titles">
        <div class="section-container">
          <div class="company__setting--section-heading">
            <p>Departments:</p>
            <p>
              Add departments and associated designations that exist in your
              company.
            </p>
          </div>

          <div class="company_setting--adddept">
            <div>
              <div class="input-wrap">
                <input
                  placeholder="e.g Engineering"
                  v-model.trim="department"
                  type="text"
                />
                <small>Error</small>
              </div>
              <button @click.prevent="addNewDepartment">
                + Add Department
              </button>
            </div>
          </div>

          <div
            v-show="departments.length > 0"
            class="company__setting--titles-card__heading"
          >
            <span>Title</span>
            <span></span>
          </div>
          <div
            v-show="departments.length > 0"
            class="company__setting-cards company__setting--titles-cards"
          >
            <div v-for="(dept, index) in departments" v-bind:key="dept.id">
              <div @click="displayTitle(index)">
                <p>
                  {{ dept.name }}
                  <span class="title-icon">
                    <font-awesome-icon icon="edit" class="myIcon" /> Edit</span
                  >
                </p>

                <div>
                  <span v-if="index === activeTitle">
                    <font-awesome-icon icon="angle-up" />
                  </span>
                  <span v-else-if="index !== activeTitle">
                    <font-awesome-icon icon="angle-down" />
                  </span>
                </div>
              </div>
              <div class="designation--section" v-show="index === activeTitle">
                <table v-if="dept.designations.length > 0">
                  <tr>
                    <th style="width: 5%">S/N</th>
                    <th>Designation</th>
                    <th style="width: 80%">Action</th>
                  </tr>

                  <tr
                    v-for="(desig, indexxx) in dept.designations"
                    :key="desig.id"
                  >
                    <td style="width: 10%">{{ indexxx + 1 }}</td>
                    <td>
                      <div v-if="editMode === indexxx">
                        <div class="editmode">
                          <input v-model="updatedDesignation.name" />
                          <div class="desigIconContainer">
                            <div
                              class="desigIcon"
                              @click="updateDesignation(dept.id, desig.id)"
                            >
                             Save
                            </div>
                            <div
                              class="desigIcon"
                              @click="toggleEdit(indexxx, desig)"
                              >
                             Cancel
                            </div>
                          </div>
                        </div>

                        <small v-if="errorMessage" class="desigError">{{
                          errorMessage
                        }}</small>
                      </div>
                      <div v-else>
                        {{ desig.name }}
                      </div>
                    </td>
                    <td>
                      <div
                        class="button_slide slide_right"
                        @click="toggleEdit(indexxx, desig)"
                      >
                        Edit
                      </div>
                      <div
                        class="button_slide slide_right"
                        @click="deleteDesignation(dept.id, desig.id)"
                      >
                        Delete
                      </div>
                    </td>
                  </tr>
                </table>

                <div class="designation--wrapper">
                  <div class="company_setting--adddept">
                    <div>
                      <div class="input-wrap">
                        <input
                          placeholder="e.g Senior Frontend Engineer"
                          v-model.trim="designation"
                          type="text"
                        />
                      </div>
                      <button @click.prevent="addNewDesignation(dept.id)">
                        + Add Designation
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import InputLoader from "../../partials/input-loader";
import WhiteLoader from "../../partials/white-loader";
import LevelsForm from "./levelsForm";
import TitlesForm from "./titlesForm";

export default {
  name: "CompanySetting",
  components: {
    InputLoader,
    WhiteLoader,
    LevelsForm,
    TitlesForm,
  },
  data() {
    return {
      errorMessage: "",
      updatedDesignation: { id: null, name: "" },
      editMode: null,
      departments: [],
      scrollToJobTitle: false,
      toEdit: true,
      submitLoader: false,
      fileError: false,
      uploadedFile: false,
      formError: false,
      networkError: false,
      successMsg: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      previewImage: "",
      titlesValue: "",
      countryData: "",
      country: false,
      stateData: "",
      state: false,
      industryData: "",
      industry: false,
      department: "",
      departmentError: null,
      designation: "",
      activeDepartmentId: "",
      titles: [
        {
          title: "Managing Director",
          level: "Level 1",
        },
      ],
      departments: [],
      legalName: "",
      registration: "",
      bvn: "",
      selectedCountry: "Nigeria",
      selectedState: "",
      city: "",
      selectedIndustry: "",
      address: "",
      website: "",
      email: "",
      phone: "",
      tax: "",
      newLevel: true,
      newDepartment: true,
      activeTitle: 0,
    };
  },
  mounted() {
    this.getDepartments();
    this.getCountryOnLoad();
    this.getIndustryOnLoad();
    const hash = window.location.hash;

    if (hash === "#company") {
      this.scrollToJobTitle = true;
    }
  },
  created() {
    let user = this.$store.getters.currentAuthUser;

    this.getDesignations();

    this.$http
      .get(`${types.COMPANY_GET_API}/${user.employees.company_id}`)
      .then((resp) => {
        let companyDetails = resp.data.data;

        this.legalName = companyDetails.trading_name;
        this.registration = companyDetails.registration_number;
        this.bvn = companyDetails.bvn;
        this.address = companyDetails.address;
        this.website = companyDetails.website;
        this.email = companyDetails.email;
        this.phone = companyDetails.phone;
        this.tax = companyDetails.tax_number;
        this.city = companyDetails.city;
        this.selectedState = companyDetails.state.name;
        this.selectedIndustry = companyDetails.industry
          ? companyDetails.industry
          : "";
      })
      .catch();
  },
  methods: {
    toggleEdit(indexxx, desig) {
      if (this.editMode === indexxx) {
        this.editMode = null;
        this.errorMessage = "";
      } else {
        this.editMode = indexxx;
        this.updatedDesignation = { ...desig };
      }
    },
    scroll() {
      const target = this.$refs.targetDiv;
      if (target && typeof target.scrollIntoView === "function") {
        target.scrollIntoView({ behavior: "smooth" });
      }
    },
    startEdit() {
      this.toEdit = !this.toEdit;
    },
    displayTitle(index) {
      if (index === this.activeTitle) {
        this.activeTitle = null;
      } else {
        this.activeTitle = index;
      }
    },
    startAddLevel() {
      this.newLevel = !this.newLevel;
    },
    startAddDepartment() {
      this.newDepartment = !this.newDepartment;
    },
    addTitle() {
      if (this.titlesValue) {
        this.title.push(this.titlesValue);
      }
    },
    removeItem(index, arr) {
      arr.splice(index, 1);
    },
    getCompanyLogo() {
      this.fileName = this.$refs.company;
      this.file = this.$refs.company.files[0];
      const ext = this.fileName.value.split(".").pop();

      if (
        ext.toLowerCase().trim() === "png" ||
        ext.toLowerCase().trim() === "jpg"
      ) {
        this.fileError = false;
        if (this.file) {
          this.uploadedFile = true;
          this.uploadedFileName = this.fileName.value.split("\\").pop();
          this.previewImage = URL.createObjectURL(this.file);
        }
        return;
      }
      this.fileError = true;
      this.uploadedFile = false;
      return;
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    getDesignations() {
      this.$http
        .get(types.GET_DESIGNATION_API)
        .then((resp) => {
          this.titles = resp.data.data;
        })
        .catch((err) => {
          this.errorMsg = err.message;
        });
    },
    getState(event) {
      this.state = false;

      for (let index = 0; index < this.countryData.length; index++) {
        if (
          event.target.value.trim().toLowerCase() ===
          this.countryData[index].name.trim().toLowerCase()
        ) {
          this.$http
            .get(`${types.STATE_API}/${this.countryData[index].id}`)
            .then((resp) => {
              if (this.isJson(resp.data.data)) {
                this.stateData = JSON.parse(resp.data.data);
              } else {
                this.stateData = resp.data.data;
              }
            });
        }
      }
    },
    getCountryOnLoad() {
      this.$http.get(types.COUNTRY_API).then((resp) => {
        if (this.isJson(resp.data.data)) {
          this.countryData = JSON.parse(resp.data.data);
        } else {
          this.countryData = resp.data.data;
        }

        if (this.countryData) {
          this.country = true;

          for (let index = 0; index < this.countryData.length; index++) {
            if (
              this.selectedCountry.trim().toLowerCase() ===
              this.countryData[index].name.trim().toLowerCase()
            ) {
              this.$http
                .get(`${types.STATE_API}/${this.countryData[index].id}`)
                .then((resp) => {
                  if (this.isJson(resp.data.data)) {
                    this.stateData = JSON.parse(resp.data.data);
                  } else {
                    this.stateData = resp.data.data;
                  }

                  if (this.stateData) {
                    this.state = true;
                  }
                });
            }
          }
        }
      });
    },
    getIndustryOnLoad() {
      this.$http.get(types.INDUSTRY_API).then((resp) => {
        if (this.isJson(resp.data.data)) {
          this.industryData = JSON.parse(resp.data.data);
        } else {
          this.industryData = resp.data.data;
        }
        this.selectedIndustry = this.selectedIndustryValue;
        this.industry = true;
      });
    },
    submitSettingUpdate() {
      this.formError = false;
      this.networkError = false;
      this.submitLoader = false;
      this.successMsg = false;

      if (!this.tax || this.tax.trim() === "") {
        this.formError = true;
        return;
      }

      if (!this.legalName || this.legalName.trim() === "") {
        this.formError = true;
        return;
      }

      if (!this.registration || this.registration.trim() === "") {
        this.formError = true;
        return;
      }

      if (!this.bvn || this.bvn.trim() === "") {
        this.formError = true;
        return;
      }

      const expression = /\S+@\S+\.\S+/;
      if (!expression.test(this.email.trim())) {
        this.formError = true;
        return;
      }

      if (isNaN(this.phone)) {
        this.formError = true;
        return;
      }

      if (this.selectedCountry) {
        for (let index = 0; index < this.countryData.length; index++) {
          if (
            this.selectedCountry.trim().toLowerCase() ===
            this.countryData[index].name.trim().toLowerCase()
          ) {
            var selectedCountryValue = this.countryData[index].id;
          }
        }
      } else {
        this.formError = true;
        return;
      }

      if (this.selectedState) {
        for (let index = 0; index < this.stateData.length; index++) {
          if (
            this.selectedState.trim().toLowerCase() ===
            this.stateData[index].name.trim().toLowerCase()
          ) {
            var selectedstateValue = this.stateData[index].id;
          }
        }
      } else {
        this.formError = true;
        return;
      }

      if (this.selectedIndustry) {
        for (let index = 0; index < this.industryData.length; index++) {
          if (
            this.selectedIndustry.trim().toLowerCase() ===
            this.industryData[index].name.trim().toLowerCase()
          ) {
            var selectedIndustryValue = this.industryData[index].id;
          }
        }
      } else {
        this.formError = true;
        return;
      }

      this.submitLoader = true;

      const formData = {
        tax_number: this.tax,
        trading_name: this.legalName,
        type: "null",
        registration_number: this.registration,
        bvn: this.bvn,
        address: this.address,
        country: selectedCountryValue,
        state: selectedstateValue,
        city: this.city,
        email: this.email,
        phone: this.phone,
        website: this.website,
        industry: selectedIndustryValue || "null",
        levels: this.levels,
        designations: this.title,
      };

      this.$http
        .put(types.COMPANY_UPDATE_API, formData)
        .then(() => {
          this.submitLoader = false;
          this.successMsg = true;
        })
        .catch((error) => {
          this.submitLoader = false;
          if (error.response.status === 500) {
            this.networkError = true;
          }
        });
    },
    addNewDepartment() {
      if (this.department === "") {
        return;
      }

      this.$http
        .post(types.CREATE_DEPARTMENT, {
          name: this.department,
        })
        .then((resp) => {
          let dept = resp.data.data;

          this.departments.unshift({
            id: dept.id,
            name: dept.name,
            designations: [],
          });

          this.department = "";
        })
        .catch((error) => {});
    },
    addNewDesignation(deptId) {
      if (deptId === "") {
        return;
      }

      const dept = this.departments.find((item) => item.id === deptId);

      if (!dept) {
        return;
      }

      this.$http
        .post(types.CREATE_DESIGNATION, {
          name: this.designation,
          department_id: deptId,
        })
        .then((resp) => {
          let desig = resp.data.data;

          dept.designations.push({
            id: desig.id,
            name: desig.name,
          });
          this.designation = "";
        })
        .catch((error) => {});
    },
    getDepartments() {
      this.$http
        .get(types.GET_DEPARTMENTS)
        .then((resp) => {
          this.departments = resp.data.data;
        })
        .catch((error) => {});
    },
    deleteDesignation(deptId, desigId) {
      this.$http
        .delete(`${types.DELETE_DESIGNATION}/${desigId}`)
        .then((resp) => {
          const dept = this.departments.find((dept) => dept.id === deptId);
          if (dept) {
            const index = dept.designations.findIndex(
              (desig) => desig.id === desigId
            );
            if (index !== -1) {
              dept.designations.splice(index, 1);
            }
          }
        })
        .catch((error) => {});
    },
    updateDesignation(deptId, desigId) {
      if (!this.updatedDesignation.name) {
        this.errorMessage = "Designation name is required.";
        return;
      }

      const url = `${types.DELETE_DESIGNATION}/${deptId}/${desigId}`;

      this.$http
        .put(url, {
          name: this.updatedDesignation.name,
        })
        .then((resp) => {
          const department = this.departments.find(
            (dept) => dept.id === deptId
          );
          if (department) {
            const designation = department.designations.find(
              (d) => d.id === desigId
            );
            if (designation) {
              designation.name = this.updatedDesignation.name;
              this.editMode = null;
              this.errorMessage = "";
            }
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.desigIconContainer {
  width: 4rem;
  cursor: pointer;
}
.desigIcon {
  border: 2px solid #969898;
  display: flex;
  justify-content: center;
  font-size: 0.75rem;
}
.desigIcon:hover {
  border: 2px solid #00070a;
}
.editmode {
  display: flex;
  input {
    padding: 0.5rem;
  }
  button {
    width: 20%;
    color: white;
    background: #162b4c;
    border: none;
  }
}
.desigError {
  color: red;
}

.scrollButton {
  width: full;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15vw;
    height: 3rem;
    word-wrap: break-word;
    padding: 10px;
    background-color: #5099de;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin: 0 auto;
    animation: bounce 0.5s;
    animation-direction: alternate;
    animation-timing-function: cubic-bezier(0.5, 0.05, 1, 0.5);
    animation-iteration-count: infinite;
  }

  @keyframes bounce {
    from {
      transform: translate3d(0, 0, 0);
    }
    to {
      transform: translate3d(0, 20px, 0);
    }
  }
  button:hover {
    background-color: #162b4c;
    border: #162b4c;
  }

  @media (max-width: 750px) {
    button {
      width: 75vw;
    }
  }
}

.myIcon {
  margin-left: 2rem;
  color: #5099de;
  height: 10px;
}

.title-icon {
  font-style: italic;
  font-size: 0.6rem;
  color: #707070;
  cursor: pointer;
}

.title-icon:hover {
  color: #5099de;
}

.button_slide {
  color: #fdf9f9;
  background: #009cee;
  border: 2 solid #5099de;
  text-align: center;
  font-size: 0.781rem;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  border-radius: 5px;
  padding: 6px 10px;
  display: inline-block;
  margin-bottom: 2px;
  cursor: pointer;
  box-shadow: inset 0 0 0 0 #009cee;
  -webkit-transition: ease-out 0.4s;
  -moz-transition: ease-out 0.4s;
  transition: ease-out 0.4s;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.slide_right:hover {
  box-shadow: inset 400px 0 0 0 rgb(1, 83, 128);
  color: #f6f0f0;
}

.company__setting {
  font-family: "Nunito", sans-serif;
  padding-top: 56px;
  padding-bottom: 150px;
  width: 55rem;
  color: #000;

  @media (max-width: 768px) {
    width: 100%;
  }

  form {
    > .company__setting--basic {
      overflow: hidden;

      > span {
        font-size: 0.938rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: normal;
        text-align: center;
        color: red;
        margin-top: 20px;
        font-style: italic;
      }

      > p {
        font-size: 1.458rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
        margin-top: 30px;
      }

      > div:last-of-type {
        padding: 0;
      }

      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        align-content: center;
        padding-bottom: 50px;

        .company__setting--basic-text {
          width: 9.323rem;
          font-size: 1.042rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #707070;

          // @media (max-width: 768px) {
          //   width: 24rem;
          // }

          > span {
            color: red;
          }
        }
        .bvn-input {
          margin-right: 1.6rem;
        }

        .bvn-span {
          font-size: 0.6rem;
          color: #939393;
        }

        .company__setting--basic-input {
          width: 20rem;
          border-radius: 1px;
          height: 40px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;

          > input {
            height: 40px;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: left;
            color: #707070;
          }

          > select {
            height: 40px;
            background-color: transparent;
            border: 0;
            outline: 0;
            padding: 0 10px;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: left;
            color: #707070;
            -moz-appearance: none;
            -webkit-appearance: none;
            position: relative;
            z-index: 2;

            ::-ms-expand {
              display: none;
            }
          }

          > div {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 100%;
            text-align: center;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }

        .company__setting--basic-textarea {
          width: 300px;
          border-radius: 1px;
          height: 100px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;

          > textarea {
            height: 100px;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 5px;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: left;
            color: #707070;
            resize: none;
          }
        }

        .company__setting--basic-input-loader {
          width: 300px;
          border-radius: 1px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;

          @media (max-width: 1400px) {
            height: 40px;
          }
        }

        .company__setting--basic-logo {
          width: 32.083vw;
          border-radius: 1px;
          overflow: hidden;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          align-content: center;

          > .company__setting--basic-logo-image {
            width: 6.042vw;
            object-fit: contain;
            margin-right: 4.063vw;
          }
          > .company__setting--basic-logo-select {
            width: 8.646vw;
            height: 116px;
            border: dotted 1px #009cee;
            cursor: pointer;
            overflow: hidden;
            position: relative;

            > div {
              width: 22.6px;
              height: 20.3px;
              object-fit: contain;
              margin: 2rem auto 0 auto;
            }

            > p {
              font-size: 0.938rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.22;
              letter-spacing: normal;
              text-align: center;
              color: #009cee;
              margin-top: 5px;
            }

            > img {
              width: 100%;
            }

            > input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background: red;
              opacity: 0;
              cursor: pointer;
            }
          }
        }

        .company__setting--basic-error {
          font-style: italic;
          font-size: 0.833rem;
          color: red;
          text-align: center;
        }
      }
    }

    > .company__setting--error {
      height: 50px;
      font-size: 0.938rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      letter-spacing: normal;
      text-align: left;
      color: red;
      margin-top: 5px;
      font-style: italic;
    }

    .company__setting--save {
      margin-top: 5px;

      > button {
        width: 9.063rem;
        height: 40px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        outline: 0;
        border: 0;

        @media (max-width: 768px) {
          width: 100%;
        }
      }

      > div {
        width: 9.063vw;
        height: 40px;
        border-radius: 5px;
        background-color: #5099de;
        font-size: 0.781rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        outline: 0;
        border: 0;
      }
    }
  }

  > .company__setting--sections {
    padding: 56px 0;
    font-size: 0.952rem;
    width: 75vw;

    @media (max-width: 768px) {
      width: 100%;
    }

    > .company__setting--section {
      margin-bottom: 60px;

      > .section-container {
        > .company__setting--section-heading {
          > :nth-child(1) {
            font-size: 1.171rem;
          }

          > p {
            margin-bottom: 35px;
            font-size: 0.952rem;
            color: #000000;
          }
        }

        > div {
          > input {
            height: 50px;
            width: 44%;
            outline: 0;
            border: 1px dashed #5099de;
          }

          > input::placeholder {
            color: #5099de;
            text-align: center;
          }
        }
      }
    }

    .company__setting--titles-card__heading {
      margin-top: 30px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      width: 70%;
      padding: 0 5px;

      > span {
        flex: 0 0 45%;
      }
    }

    .company__setting-cards {
      border-top: 2px solid #5099de;
      width: 75%;

      @media (max-width: 768px) {
        width: 100%;
      }

      > div {
        margin-bottom: 20px;
        padding-bottom: 15px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

        > :nth-child(1) {
          display: flex;
          height: 10px;
          padding: 20px;

          > div {
            width: max-content;
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            > :nth-child(1) {
              color: #5099de;
            }

            > span {
              width: max-content;
              margin: 0 10px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .company_setting--adddept {
    > div {
      display: flex;
    }
    .input-wrap {
      width: 300px;
      border-radius: 1px;
      height: 40px;
      border: solid 1px #c7c7c7;
      background-color: #ffffff;
      overflow: hidden;
      position: relative;
    }
    input {
      height: 40px;
      background-color: #ffffff;
      border: 1px;
      outline: 0;
      padding: 0 5px;
      font-size: 1rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #707070;
    }

    button {
      width: 9.063rem;
      height: 40px;
      border-radius: 5px;
      background-color: #5099de;
      font-size: 0.781rem;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      outline: 0;
      border: 0;
      margin-left: 10px;
    }
  }
}
table {
  // width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
// td:nth-child(1) {
//   width: 10%; /* Adjust as needed */
// }
// tr:hover {
//   background-color: #ddd;
// }

// tr:nth-child(even) {
//   background-color: #dddddd;
// }
.designation--section {
  padding: 10px;
}

.designation--wrapper {
  padding: 10px 0;
}
</style>